export interface Product {
  id?: string;
  name?: string;
  industry_type?: IndustryType;
  full_price?: number;
  stripe_product_id?: string;
  stripe_price_id?: string;
  trial_period_days?: number;
  marketing_bullet_points?: string[];
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  deleted_at?: string;
  deleted_by?: string;
  stripe_info?: StripeProductInfo;
  has_stripe_info?: boolean;
}

export interface StripeProductInfo {
  name?: string;
  description?: string;
  active?: boolean;
  current_price?: number;
  currency?: string;
  stripe_price_id?: string;
  interval?: string;
  interval_count?: number;
}

export interface ProductFeature {
  id?: string;
  product_id?: string;
  feature?: string; // The actual database column name
  is_active?: boolean;
  feature_limit?: number;
  created_at?: string;
  updated_at?: string;
}

export enum ProductFeatureType {
  MULTI_USER = "multi_user",
  SOCIAL_MEDIA = "social_media",
  VIDEOS = "videos"
}

export enum IndustryType {
  MEDICAL_WELLNESS = "medical_wellness",
  REAL_ESTATE = "real_estate",
  LEGAL_SERVICES = "legal_services",
  OTHER = "other"
}

